// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../core/resource.mjs";
import { ArrayPage } from "../core/pagination.mjs";
import { path } from "../internal/utils/path.mjs";
export class Tools extends APIResource {
    /**
     * Create a new tool
     */
    create(body, options) {
        return this._client.post('/v1/tools/', { body, ...options });
    }
    /**
     * Get a tool by ID
     */
    retrieve(toolID, options) {
        return this._client.get(path `/v1/tools/${toolID}`, options);
    }
    /**
     * Update an existing tool
     */
    update(toolID, body, options) {
        return this._client.patch(path `/v1/tools/${toolID}`, { body, ...options });
    }
    /**
     * Get a list of all tools available to agents.
     */
    list(query = {}, options) {
        return this._client.getAPIList('/v1/tools/', (ArrayPage), { query, ...options });
    }
    /**
     * Delete a tool by name
     */
    delete(toolID, options) {
        return this._client.delete(path `/v1/tools/${toolID}`, options);
    }
    /**
     * Search tools using semantic search.
     *
     * Requires tool embedding to be enabled (embed_tools=True). Uses vector search,
     * full-text search, or hybrid mode to find tools matching the query.
     *
     * Returns tools ranked by relevance with their search scores.
     */
    search(body, options) {
        return this._client.post('/v1/tools/search', { body, ...options });
    }
    /**
     * Create or update a tool
     */
    upsert(body, options) {
        return this._client.put('/v1/tools/', { body, ...options });
    }
}
//# sourceMappingURL=tools.mjs.map